// Marca ChatIa — quadradinho verde com balão + ponto roxo.
import styles from './LogoMark.module.css';
import { ChatIcon } from '@/components/icons';

interface LogoMarkProps {
  size?: number;
}

export function LogoMark({ size = 28 }: LogoMarkProps) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.square} style={{ width: size, height: size }}>
        <ChatIcon size={Math.round(size * 0.6)} />
        <span className={styles.dot} aria-hidden="true" />
      </div>
      <span className={styles.label}>
        ChatIa<span className={styles.accent}>.</span>
      </span>
    </div>
  );
}
